var OrgMemberView = Backbone.View.extend({
    tagName: 'tr',
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.model.bind('removedChange', this.renderRemoved, this);
        this.model.bind('change:admin', this.renderAdmin, this);
        if (options.undoable === undefined) {
            this.undoable = true;
        } else {
            this.undoable = options.undoable;
        }
    },
    events: {
        'click a.remove': 'clickRemove',
        'click a.undo': 'clickUndo',
        'click a.resend': 'clickResend',
        'change td.admin input[type=checkbox]': 'changeAdmin'
    },
    render: function () {
        this.adminCell = $('<td class="admin">');
        this.renderAdmin();

        this.actionCell = $('<td class="remove">');
        var removeSmall = $('<small>')
            .append($('<a href="" class="remove">').text('remove'))
            .append($('<a href="" class="undo">').text('undo'));

        var email = this.model.get('email');
        var inviteEmail = this.model.get('invite_email');
        var emailCell = $('<td class="email">');
        if (email) {
            emailCell.text(email);
            if (inviteEmail && inviteEmail != email) {
                removeSmall
                    .append(' | ')
                    .append('<span>invited as: ')
                    .append($('<span>').text(inviteEmail));
            }
        } else {
            emailCell.text(inviteEmail);
            $(this.el).addClass('pending');
            removeSmall
                .append(' | ')
                .append($('<a href="" class="resend">').text('resend invite'))
                .append($('<span class="resending">').text('sending…'))
                .append($('<span class="resendFail">').text(' failed'))
                .append($('<span class="resent">').text('sent!'));
            this.actionCell.append(removeSmall);
        }
        if (this.model.isSelf()) {
            this.actionCell.append('<small>That’s you!</small>');
        } else {
            this.actionCell.append(removeSmall);
        }

        $(this.el)
            .append(emailCell)
            .append(this.adminCell)
            .append(this.actionCell);
        return this;
    },
    clickRemove: function (e) {
        e.preventDefault();
        if (this.undoable) {
            this.model.setRemoved(true);
        } else {
            this.model.collection.remove(this.model);
        }
    },
    clickUndo: function (e) {
        e.preventDefault();
        this.model.setRemoved(false);
    },
    changeAdmin: function (e) {
        this.model.setAdmin(this.adminCell.find('input[type=checkbox]').is(':checked'));
    },
    clickResend: function (e) {
        e.preventDefault();
        this.actionCell.find('.resend').hide();
        this.actionCell.find('.resending').show();
        this.actionCell.find('.resendFail').hide();
        this.model.resendInvite(_.bind(function (response) {
            this.actionCell.find('.resending').hide();
            if (response.success) {
                this.actionCell.find('.resent').show();
            } else {
                this.actionCell.find('.resend').show();
                this.actionCell.find('.resendFail').show();
            }
        }, this));
    },
    renderRemoved: function () {
        $(this.el).toggleClass('removed', this.model.isRemoved());
    },
    renderAdmin: function () {
        var check = $('<input type="checkbox" name="admin">').prop('checked', this.model.isAdmin()).prop('disabled', this.model.isSelf());
        this.adminCell.html(check);
    }
});

module.exports = OrgMemberView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/orgmemberview.js
// module id = PQdE
// module chunks = 1